import { i18n } from '@easydata/core';
function addEasyQueryCoreTexts() {
    i18n.updateDefaultTexts({
        NewQueryName: '[New query]',
        //DateTime macroses
        Today: 'Today',
        Yesterday: 'Yesterday',
        Tomorrow: 'Tomorrow',
        FirstDayOfMonth: 'First day of the month',
        LastDayOfMonth: 'Last day of the month',
        FirstDayOfWeek: 'First day of the week',
        FirstDayOfYear: 'First day of the year',
        FirstDayOfNextWeek: 'First day of the next week',
        FirstDayOfNextMonth: 'First day of the next month',
        FirstDayOfNextYear: 'First day of the next year',
        Now: 'Now',
        HourStart: 'This hour start',
        Midnight: 'Midnight',
        Noon: 'Noon',
        Entities: {},
        Attributes: {},
        Operators: {},
        AggreateFunctions: {}
    });
}
addEasyQueryCoreTexts();
//# sourceMappingURL=text_resources.js.map